import { createReducer, on } from '@ngrx/store';
import * as FeatureFlagActions from './feature-flag.actions';
import { FeatureFlag } from 'projects/uzurv/src/services/feature-flag/feature-flag.interfaces';

export interface FeatureFlagState {
  isInitialized: boolean;
  flags: Record<string, FeatureFlag>;
}

export const initialState: FeatureFlagState = {
  isInitialized: false,
  flags: {}
};

export const featureFlagsReducer = createReducer(
  initialState,

  on(FeatureFlagActions.InitializeFeatureFlagsSuccess, state => ({
    ...state,
    isInitialized: true
  })),

  on(FeatureFlagActions.RehydrateFeatureFlagsSuccess, (state, action) => {
    return {
      ...state,
      flags: action.flags
    };
  })
);
